var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx } from "react/jsx-runtime";
import { PeriodComparisonSplitColumnTooltip } from '@web/components/layout/RechartsItems/PeriodComparisonSplitColumnTooltip';
import { DRIVE_ACTIONS_OVER_TIME_COLORS_CONFIG } from '@web/config';
import { ComparisonPeriod, getPeriodComparisonSection } from '@web/utility/ tooltip/periodComparisonTooltip';
var resolveDriveSwatchColor = function (dataKey, metricKey, stripeSwatchColors) {
    var key = metricKey;
    var section = getPeriodComparisonSection(dataKey);
    var stripeColor = stripeSwatchColors === null || stripeSwatchColors === void 0 ? void 0 : stripeSwatchColors[dataKey];
    if (section === ComparisonPeriod.Team) {
        return {
            stripe: true,
            color: stripeColor !== null && stripeColor !== void 0 ? stripeColor : DRIVE_ACTIONS_OVER_TIME_COLORS_CONFIG[key].teamChartColor
        };
    }
    if (section === ComparisonPeriod.Previous) {
        return {
            color: DRIVE_ACTIONS_OVER_TIME_COLORS_CONFIG[key].prevChartColor
        };
    }
    return {
        color: DRIVE_ACTIONS_OVER_TIME_COLORS_CONFIG[key].chartColor
    };
};
export function DriveActionsOverTimeTooltip(_a) {
    var seriesOrder = _a.seriesOrder, metricLabels = _a.metricLabels, stripeSwatchColors = _a.stripeSwatchColors, showTeamAverage = _a.showTeamAverage, dateFrom = _a.dateFrom, dateTo = _a.dateTo, t = _a.t, tooltipProps = __rest(_a, ["seriesOrder", "metricLabels", "stripeSwatchColors", "showTeamAverage", "dateFrom", "dateTo", "t"]);
    return (_jsx(PeriodComparisonSplitColumnTooltip, __assign({}, tooltipProps, { seriesOrder: seriesOrder, metricLabels: metricLabels, showTeamAverage: showTeamAverage, dateFrom: dateFrom, dateTo: dateTo, t: t, resolveSwatchColor: function (dataKey, metricKey) {
            return resolveDriveSwatchColor(dataKey, metricKey, stripeSwatchColors);
        } })));
}
